module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "tree-breadcrumb-child"
  }, [_c('span', {
    staticClass: "tree-breadcrumb-innner",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.clickHandle(_vm.item)
      }
    }
  }, [_vm._t("default", [_vm._v(_vm._s(_vm.item.name))])], 2), _vm._v(" "), _c('svg', {
    staticClass: "tree-svg-breadcrumb tree-svg-color-default",
    attrs: {
      "viewBox": "0 0 1024 1024",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M568.00288375 512.01152332L384.41482981 333.95461835c-13.22866482-12.81382867-13.55131526-33.97047364-0.73748659-47.199138 0.23046473-0.23046473 0.50702186-0.460929 0.7374866-0.73748659 13.78177954-13.36694338 35.67591109-13.36694338 49.41159775 0l203.91502614 197.73857677c15.57940315 15.11847414 15.9942393 40.00864444 0.87576561 55.58804714l-0.82967276 0.82967274-203.91502613 197.73857631c-13.78177954 13.36694338-35.67591109 13.36694338-49.41159776 0-13.22866482-12.81382867-13.55131526-33.97047364-0.7374866-47.199138l0.7374866-0.73748659L568.00288375 512.01152332z"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-02fce9a2!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/source/breadcrumb-item.vue
// module id = 317
// module chunks = 0